export default __webpack_public_path__ + "static/kentcdodds-58d3178a89b5ffa6d29a993c21762c5c.png";